import { render, staticRenderFns } from "./WorkflowComment.vue?vue&type=template&id=4563c0dc&scoped=true"
import script from "./WorkflowComment.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowComment.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WorkflowComment.vue?vue&type=style&index=0&id=4563c0dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4563c0dc",
  null
  
)

export default component.exports